import React, { memo, useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Box } from "@mui/material";
import Paper from "@mui/material/Paper";
import useDeviceDetect from "../../../Detect/useDeviceDetect ";
import OutstandingCustomerTable from "./OutstandingCustomerTable";
import OutstandingCustomerCard from "./OutstandingCustomerCard";
import PopupDialogTitle from "../../../Dialog/PopupDialogTitle";
import Calculation from "../../../../utility/Calculations";
import { useDispatch, useSelector } from "react-redux";
import { triggerLoader } from "../../../../redux/reducers/LoaderTrigger";
import DownloadPdf from "../../../Download/DownloadPdf";
import CheckAndReturn from "../../../../utility/CheckAndReturn";
//FUNCTION
const OutstandingPopup = memo(
  ({
    openOutstandingPopup,
    handleOutstandingPopup,
    outstandingCustomerData,
    getCustomerLedgerdata,
    companyLogo,
  }) => {
    //#region
    const { isMobile } = useDeviceDetect();
    const dispatch = useDispatch();
    const outstandingRef = useRef();
    const pdfRef = useRef(); // Create a reference for DownloadPdf component
    const [pdfData, setPdfData] = useState([]); // Store PDF data in state
    const handlePrint = useReactToPrint({
      content: () => outstandingRef.current,
      documentTitle: "Outstanding Ledger",
    });
    // console.log("getCustomerLedgerdata==", getCustomerLedgerdata);
    const { company_id, companyName } = useSelector(
      (state) => state.GlobalVariables
    );

    const [invoiceAmount, setInvoiceAmount] = useState(0);
    const [receiptAmount, setReceiptAmount] = useState(0);
    const [paymentAmount, setPaymentAmount] = useState(0);
    const [duesAmount, setDuesAmount] = useState(0);

    useEffect(() => {
      let totalInvoiceAmount = 0;
      let totalReceiptAmount = 0;
      let totalPaymentAmount = 0;

      if (outstandingCustomerData !== null) {
        outstandingCustomerData.ledger.forEach((row) => {
          if (row.type === "sale") {
            totalInvoiceAmount += Number(row.amount ?? 0);
          } else if (Boolean(row.is_credit) === false) {
            totalReceiptAmount += Number(row.amount ?? 0);
          } else if (Boolean(row.is_credit) === true) {
            totalPaymentAmount += Number(row.amount ?? 0);
          }
        });

        setInvoiceAmount(totalInvoiceAmount);
        setReceiptAmount(totalReceiptAmount);
        setPaymentAmount(totalPaymentAmount);

        const calculatedDues = CheckAndReturn.roundToInteger(
          (totalInvoiceAmount ?? 0) +
            (totalPaymentAmount ?? 0) -
            (totalReceiptAmount ?? 0)
        );
        setDuesAmount(calculatedDues);
      }

      return () => {
        setInvoiceAmount(0);
        setReceiptAmount(0);
        setPaymentAmount(0);
        setDuesAmount(0); // reset on unmount
      };
    }, [outstandingCustomerData]);

    const handleDownload = () => {
      const formattedData = getCustomerLedgerdata
        .filter(
          (order) =>
            order.type === "sale" ||
            order.type === "receipt" ||
            order.type === "salesreturn" ||
            order.type === "journal" || 
            order.type === "payment" // <-- Add this line
        )
        .map((order, index) => {
          const isCredit = Boolean(order.is_credit) === false;
          const creditDebitLabel = isCredit ? "Cr" : "Dr";

          const description =
            order.type === "sale"
              ? `Bill To: ${order.entity_number}`
              : order.type === "salesreturn"
              ? `Return from: ${order.entity_number}`
              : order.type === "journal"
              ? `Journal Entry: ${order.entity_number}`
              : `Payment: ${order.entity_number}`;

          return [
            (index + 1).toString(),
            description,
            order.date,
            `Rs. ${CheckAndReturn.roundToInteger(
              order.amount ?? 0
            )} ${creditDebitLabel}`,
          ];
        });

      setPdfData(formattedData);
    };

    // Jab pdfData update hoga, tabhi PDF generate hoga
    useEffect(() => {
      if (pdfData.length > 0 && pdfRef.current) {
        pdfRef.current.generatePdf();
      }
    }, [pdfData]); // pdfData change hone pe hi chalega

    return (
      <>
        <Dialog
          open={openOutstandingPopup}
          onClose={handleOutstandingPopup}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth={false}
          PaperProps={{
            sx: {
              width: "90%",
              height: "80%",
            },
          }}
        >
          <PopupDialogTitle
            handleDownload={handleDownload}
            handlePrint={handlePrint}
            handleClose={handleOutstandingPopup}
          />

          <DownloadPdf
            ref={pdfRef}
            headers={["S.No.", "Type", "Date", "AMOUNT"]}
            data={pdfData}
            fileName="Outstanding_Ledger"
            title="Ledger Report"
            companyName={companyName}
            logo={companyLogo} // ✅ Pass company logo
            showTotalAmount={false} // ✅ Set to true to display total
            setOpenBackdrop={(status) => dispatch(triggerLoader(status))}
            customerName={outstandingCustomerData?.name ?? ""}
            summaryData={{
              invoice: CheckAndReturn.roundToInteger(invoiceAmount),
              payment: CheckAndReturn.roundToInteger(paymentAmount),
              receipt: CheckAndReturn.roundToInteger(receiptAmount),
              dues: duesAmount,
            }}
          />

          <DialogContent>
            {isMobile ? (
              <Box
                component={Paper}
                sx={{
                  padding: "16px",
                  backgroundColor: "#fff",
                  overflowY: "auto",
                  maxHeight: "100vh",
                }}
                ref={outstandingRef}
              >
                <OutstandingCustomerCard
                  outstandingCustomerData={outstandingCustomerData}
                />
              </Box>
            ) : (
              <Box
                component={Paper}
                sx={{
                  padding: "16px",
                  backgroundColor: "#fff",
                  overflowY: "auto",
                  maxHeight: "80vh",
                }}
                ref={outstandingRef}
              >
                <OutstandingCustomerTable
                  outstandingCustomerData={outstandingCustomerData}
                />
              </Box>
            )}
          </DialogContent>
        </Dialog>
      </>
    );
  }
);

export default memo(OutstandingPopup);
